import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  // Friendly toast palette — no more alarm-red destructive toasts that scare
  // users into thinking the app is broken. Errors use a soft amber border,
  // success uses a calm emerald, info/warning stay subtle. All toasts keep the
  // app's background so they feel like part of the UI, not flash warnings.
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white dark:group-[.toaster]:bg-slate-900 group-[.toaster]:text-slate-900 dark:group-[.toaster]:text-slate-100 group-[.toaster]:border group-[.toaster]:border-slate-200 dark:group-[.toaster]:border-slate-700 group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg",
          description: "group-[.toast]:text-slate-600 dark:group-[.toast]:text-slate-400",
          actionButton:
            "group-[.toast]:bg-blue-600 group-[.toast]:text-white hover:group-[.toast]:bg-blue-700",
          cancelButton:
            "group-[.toast]:bg-slate-100 dark:group-[.toast]:bg-slate-800 group-[.toast]:text-slate-700 dark:group-[.toast]:text-slate-300",
          // All toasts use the site theme — soft blue for errors and warnings
          // (no alarm-red or amber), calm emerald for success, blue for info.
          error:
            "group-[.toaster]:!bg-blue-50 dark:group-[.toaster]:!bg-blue-950/40 group-[.toaster]:!border-blue-300 dark:group-[.toaster]:!border-blue-700 group-[.toaster]:!text-blue-900 dark:group-[.toaster]:!text-blue-100",
          warning:
            "group-[.toaster]:!bg-blue-50 dark:group-[.toaster]:!bg-blue-950/40 group-[.toaster]:!border-blue-300 dark:group-[.toaster]:!border-blue-700 group-[.toaster]:!text-blue-900 dark:group-[.toaster]:!text-blue-100",
          // Subtle emerald success
          success:
            "group-[.toaster]:!bg-emerald-50 dark:group-[.toaster]:!bg-emerald-950/40 group-[.toaster]:!border-emerald-300 dark:group-[.toaster]:!border-emerald-700 group-[.toaster]:!text-emerald-900 dark:group-[.toaster]:!text-emerald-100",
          info:
            "group-[.toaster]:!bg-blue-50 dark:group-[.toaster]:!bg-blue-950/40 group-[.toaster]:!border-blue-300 dark:group-[.toaster]:!border-blue-700 group-[.toaster]:!text-blue-900 dark:group-[.toaster]:!text-blue-100",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
